import React from "react";
import { CheckCircle2Icon, TargetIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { volumes } from "../data/landing";
export function Volumes() {
  return <section className="bg-navy px-4 py-16 sm:py-20" aria-labelledby="volumes" data-id="element-305" data-mp="185gecasyuarb">
      <div className="mx-auto max-w-5xl" data-id="element-306" data-mp="1c6ib8kzeuaq4">
        <SectionHeading title={<span id="volumes" data-id="element-308" data-mp="1zujk5v0i3t62">What will you find inside the Blueprint™?</span>} intro="Six structured volumes, each built around one stage of orthopedic test interpretation." data-id="element-307" data-mp="1c34atiab4blb" />

        <div className="space-y-6" data-id="element-309" data-mp="1quweuy4ni37q">
          {volumes.map(v => <article key={v.number} className="overflow-hidden rounded-3xl bg-panel" data-id="element-310" data-mp="1qwpmogr02thb">
              <div className="flex items-center gap-4 bg-ink px-5 py-4 sm:px-7" data-id="element-311" data-mp="1vvkgedqia2g7">
                <div className="flex h-16 w-16 shrink-0 flex-col items-center justify-center rounded-xl bg-gold text-ink" data-id="element-312" data-mp="fdmxqi8zvn9l">
                  <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-313" data-mp="kc812qjjmn29">Volume</span>
                  <span className="font-display text-2xl font-extrabold leading-none" data-id="element-314" data-mp="3oa9c0v1o1jcs">{v.number}</span>
                </div>
                <h3 className="font-display text-[26px] font-extrabold uppercase leading-[1.05] text-white sm:text-3xl" data-id="element-315" data-mp="20ovbyfhu0co">{v.title}</h3>
              </div>

              <div className="p-5 sm:p-7" data-id="element-316" data-mp="3t5oobik0z773">
                <p className="text-[18px] font-bold leading-snug text-cyan" data-id="element-317" data-mp="b1da4vcpo4qm">{v.lead}</p>
                <p className="mt-2 text-[15px] leading-relaxed text-mist" data-id="element-318" data-mp="azadhsh1zdcx">{v.body}</p>

                <p className="mt-5 text-[13px] font-bold uppercase tracking-wider text-white" data-id="element-319" data-mp="60h70k06omm9">Inside Volume {v.number}</p>
                <ul className="mt-3 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-320" data-mp="fsmxtqep8xzv">
                  {v.items.map(item => <li key={item} className="flex gap-2.5 text-[15px] leading-snug text-slate-200" data-id="element-321" data-mp="trcw39d993pt">
                      <CheckCircle2Icon className="mt-0.5 h-[18px] w-[18px] shrink-0 text-after" aria-hidden="true" data-id="element-322" data-mp="prc7ivwfzc51" />
                      <span data-id="element-323" data-mp="wv254tlva2nq">{item}</span>
                    </li>)}
                </ul>

                <div className="mt-6 flex gap-3 rounded-2xl border border-cyan/30 bg-cyan/10 p-4" data-id="element-324" data-mp="11tc299r5jdbz">
                  <TargetIcon className="mt-0.5 h-5 w-5 shrink-0 text-cyan" aria-hidden="true" data-id="element-325" data-mp="16qcanrbh4s69" />
                  <p className="text-[15px] leading-relaxed text-white" data-id="element-326" data-mp="1bk6pohg4wiz0">
                    <span className="font-bold text-cyan" data-id="element-327" data-mp="1fl0d79pnzvrd">Your takeaway: </span>
                    {v.takeaway}
                  </p>
                </div>

                {v.number === "VI" && <p className="mt-3 text-[12px] leading-relaxed text-mist" data-id="element-328" data-mp="1pi541muggfei">
                    Educational scenarios do not constitute validated diagnostic algorithms.
                  </p>}
              </div>
            </article>)}
        </div>

        <CtaButton className="mt-10" label="I want all 6 volumes" data-id="element-329" data-mp="36zpsh9eg85" />
      </div>
    </section>;
}